import qs from 'qs';
import extend from 'lodash/extend';

export default function mapHttpOperation(operation) {
  return extend(operation, {
    form: true,
    query: qs.stringify(extend({ c: Date.now() }, operation.query || {}), {
      arrayFormat: 'brackets',
    }),
    data:
      operation.data && typeof operation.data === 'object'
        ? qs.stringify(
            extend({}, operation.data, {
              csrf_token: getCSRFToken(operation.data || {}),
            }),
            { arrayFormat: 'brackets' },
          )
        : operation.data,
    transform:
      operation.transform ||
      ((ret) => {
        return ret ? ret[0] || ret : undefined;
      }),
    headers: {
      accept: 'application/json, text/javascript, */*',
    },
  });
}

function getCSRFToken(data) {
  if (data && data.csrf_token) {
    return data.csrf_token;
  }

  const csrfTag = Array.prototype.filter
    .call(document.head.childNodes, (tag) => {
      return (
        tag.nodeName === 'META' && tag.getAttribute('name') === 'csrf-token'
      );
    })
    .pop();

  if (csrfTag) return csrfTag.getAttribute('content');
}
